/* How the customer wants to receive the parts of an offer request. */
export enum OfferRequestDeliveryType {
	Unknown = 0,
	/** The customer collects the order. */
	Pickup = 1,
	/** Blexon ships the order to one of the customer's delivery addresses. */
	Delivery = 2,
}
